// src/utils/prototypes.ts

declare global {
  interface String {
    lowerCaseIncludes(searchString: string): boolean;
    lowerCaseCompare(searchString: string): boolean;
    isJsonObject(): boolean;
  }
  interface Array<T> {
    last(): T | undefined;
  }
}

String.prototype.lowerCaseIncludes = function (searchString: string): boolean {
  return this.toLowerCase().includes(searchString.toLowerCase());
};

String.prototype.lowerCaseCompare = function (searchString: string): boolean {
  return this.toLowerCase() === searchString.toLowerCase();
};

String.prototype.isJsonObject = function (): boolean {
  try {
    const parsed = JSON.parse(String(this));
    return typeof parsed === "object" && parsed !== null;
  } catch {
    return false;
  }
};

Array.prototype.last = function <T>(): T | undefined {
  return this[this.length - 1];
};

const originalLocaleCompare = String.prototype.localeCompare;
String.prototype.localeCompare = function (that: string, locales?: string | string[], options?: Intl.CollatorOptions): number {
  return originalLocaleCompare.call(this, that, locales, { numeric: true, ...options });
};

export {};
